<template>
  <v-row class="matching" justify="center" align="center" style="overflow: hidden">
    <v-col style="display: flex; align-items: center" cols="12" justify="center">
      <v-row>
        <!-- <v-spacer></v-spacer> -->

        <v-col class="pa-8" cols="12">
          <v-row class="img_container justify-center pb-9">
            <img
              src="@/assets/img/landing/matching/mail3d.png"
              :width="$vuetify.breakpoint.mdAndUp ? '204px' : '160px'"
              data-aos="fade-up-small"
              data-aos-once="true"
              data-aos-easing="ease-out-cubic"
              data-aos-duration="600" />
          </v-row>
          <v-row
            class="title-lead justify-center pb-3"
            data-aos="fade-up-small"
            data-aos-once="true"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="700"
            data-aos-delay="200">
            무료 상담 신청이 완료되었어요!
          </v-row>
          <v-row
            class="content-lead justify-center pb-3"
            data-aos="fade-up-small"
            data-aos-once="true"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="700"
            data-aos-delay="300">
            마케팅 전문가 배정 후 영업일 기준 <br />
            24시간 이내에 연락드릴 예정이에요.
          </v-row>
          <v-row
            class="caption-lead justify-center pb-8"
            data-aos="fade-up-small"
            data-aos-once="true"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="1100"
            data-aos-delay="800">
            잠시 후 맞춤 광고 생성을 위한 회원가입 페이지로 이동합니다
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'LeadComplete',
  methods: {
    isMatching() {
      return process.env.VUE_APP_TARGET === 'campaign' || location.href.indexOf('superchart') > -1;
    },
  },
  mounted() {
    const recommended = this.$route.query.recommended || '';
    const leadId = this.$route.query.leadId || '';
    const type = this.$route.query.type || '';
    const companyName = this.$route.query.companyName || '';
    const x = this.$route.query.x || '';
    const y = this.$route.query.y || '';
    const leadSource = this.$route.query.lead_source || '';
    window.scrollTo(0, 0);

    if (this.isMatching()) {
      window.dataLayer.push({
        event: 'completeLeadSubmission',
        page: 'leadcomplete',
        objectSection: leadSource,
      });

      setTimeout(
        () =>
          this.$router.push({
            path: '/',
          }),
        4000
      );
    } else {
      let uri =
        '/signup?utm_source=organic-internal&utm_medium=link&utm_campaign=sm_company&utm_term=mkt-lead&utm_content=signupcomplete';

      if (recommended) {
        uri += `&recommended=${recommended}`;
      }

      if (leadId) {
        uri += `&leadId=${leadId}`;
      }

      if (type) {
        uri += `&type=${type}`;
      }

      if (companyName) {
        uri += `&companyName=${companyName}`;
      }

      if (x && y) {
        uri += `&x=${x}&y=${y}`;
      }

      setTimeout(
        () =>
          this.$router.push({
            path: uri,
          }),
        3000
      );
    }
  },
};
</script>

<style scoped lang="scss">
* {
  font-family: 'Pretendard';
}
.matching {
  width: 100vw;
  background: #fbfbfb;
  height: 100%;
  min-height: 90vh;
}

.title-lead {
  text-align: center;
  color: #0f1633;
  font-weight: 800;
  font-size: 27px;
  line-height: 40px;
  word-break: keep-all;
  @media only screen and (max-width: 959px) {
    font-size: 24px;
    line-height: 36px;
  }
}

.content-lead {
  text-align: center;
  color: #21232e;
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
  @media only screen and (max-width: 959px) {
    font-size: 14px;
    line-height: 28px;
  }
}

.caption-lead {
  text-align: center;
  color: #757575;
  font-weight: 400;
  font-size: 14px;
  line-height: 28px;
  @media only screen and (max-width: 959px) {
    font-size: 13px;
    line-height: 28px;
  }
}

/*  Animation starts here */
[data-aos='fade-up-small'] {
  transform: translate(0, 48px);
  opacity: 0;
  transition-property: opacity transform;
}
/*  Animation ends here */
[data-aos='fade-up-small'].aos-animate {
  transform: translate(0, 0);
  opacity: 1;
}
</style>
